/* eslint-disable indent */
import React, { useState } from 'react';
import i18n from 'i18n-js';
import { View, Text } from 'react-native';

import { getParameterByName, serialize, isPhone } from '@helpers';
import Button from '@components/button';
import TouchableElement from '@components/common/touchableElement';
import { font } from '@styles/fonts';
import { APP_STORE_URL, PLAY_STORE_URL } from '@v2/pages/common/constants/base.constants';

let showModalOneTime = true;

export default (OriginalComponent) => {
  return (props) => {
    const { inviteStatus = {} } = props;
    const [showModal, setShowModal] = useState(true);
    const appBase = 'smartfactory://';

    const close = () => {
      showModalOneTime = false;
      setShowModal(false);
    };

    const openApp = async () => {
      const getMobileOperatingSystem = () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        if (/android/i.test(userAgent)) {
          return 'Android';
        }

        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
          return 'iOS';
        }

        return 'unknown';
      };

      let os = getMobileOperatingSystem();

      switch (os) {
        case 'Android': {
          window.location.href = PLAY_STORE_URL;
          break;
        }
        case 'iOS': {
          window.location.href = APP_STORE_URL;
          break;
        }
        case 'unknown': {
          window.location.href = 'https://login.smarfac.com/qr';
        }
      }

      return;
    };

    return (
      <View style={{ width: '100%', height: '100%' }}>
        <OriginalComponent {...props} />
        {isPhone && showModalOneTime && showModal && (
          <View
            style={{
              backgroundColor: 'rgba(0,0,0,0.5)',
              position: 'absolute',
              height: '100%',
              width: '100%',
              justifyContent: 'center',
              alignContent: 'center',
              alignItems: 'center',
            }}
          >
            <View
              style={{
                position: 'absolute',
                width: '95%',
                height: 250,
                justifyContent: 'space-around',
                paddingLeft: 30,
                paddingRight: 30,
                backgroundColor: 'white',
                zIndex: 1000,
                // bottom: 40,
                borderRadius: 20,
                borderTopRightRadius: 20,
              }}
            >
              <Text style={[font['Title 2'], { color: '#000000', textAlign: 'center' }]}>
                {i18n.t('Smart Factory works better if you switch to our app')}
              </Text>
              <View
                style={{
                  justifyContent: 'center',
                  alignContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                }}
              >
                <Button
                  {...{
                    width: '100%',
                    maxWidth: 300,
                    name: i18n.t('Go to the app'),
                    onPress: openApp,
                  }}
                />
              </View>
              <TouchableElement onPress={close}>
                {({ boxStyle }) => (
                  <View style={boxStyle}>
                    <Text style={[font['Button 2'], { color: '#7e8387', textAlign: 'center' }]}>{i18n.t('Continue with mobile web')}</Text>
                  </View>
                )}
              </TouchableElement>
            </View>
          </View>
        )}
      </View>
    );
  };
};
